import { queryClient } from "~/plugins/vue-query";
import { decisionService } from "~/utils/api/decisionService";
import { getProjectId } from "~/utils/getProjectId";

export default defineNuxtRouteMiddleware(async () => {
  const projectId = getProjectId();

  if (projectId) {
    queryClient.fetchQuery({
      queryKey: ["decisions"],
      queryFn: () =>
        decisionService.getDecision({
          client_project_id: projectId,
        }),
    });
  }
});
